module.exports = __webpack_public_path__ + "318852e8ef5b518607448d3b3e61288a.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/home/components/images/blog.png
 ** module id = 1560
 ** module chunks = 0
 **/